/* eslint-disable no-constant-condition */
import React, {Component} from 'react';

import {Redirect} from 'react-router-dom';

import {client} from '../Client';
import Field from './Field';
import Checkbox from './Checkbox';
import '../styles/Login.css'

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginInProgress: false,
      shouldRedirect: false,
      errorMsg: '',
      fields: this.getEmptyFields(),
      fieldErrors: {},
    };
    this.performLogin = this.performLogin.bind(this);
    this.redirectPath = this.redirectPath.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  getEmptyFields() {
    return {username: '', password: '', rememberme: client.getRememberme()};
  }

  redirectPath() {
    const locationState = this.props.location.state;
    const pathname = (
      locationState && locationState.from && locationState.from.pathname
    );
    return pathname || '/app/attivita';
  }

  onInputChange({ name, value, error }) {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;

    fields[name] = value;
    fieldErrors[name] = error;

    this.setState({ fields, fieldErrors});
  }

  performLogin(ev) {
    ev.preventDefault(true)
    const user = this.state.fields;

    if (this.validate()) return;

    this.setState({loginInProgress: true});
    client.login(user.username, user.password, user.rememberme).then(() => (
      this.setState({shouldRedirect: true})
    )).catch((error) => {
      if (error.api && error.api.code === 10) {
        this.setState({loginInProgress: false, errorMsg: 'Credenziali non corrette. Riprova!'})
      }
      else {
        this.setState({loginInProgress: false, errorMsg: 'Opsss! Errore non previsto: ' + error.internalErrorText})
      }
    });
  }

  validate() {
    const user = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter((k) => fieldErrors[k]);

    if (!user.username) return true;
    if (!user.password) return true;
    if (errMessages.length) return true;

    return false;
  }

  render() {
    let formClass = 'ui form'
    const submitBtnDisabled = this.state.loginInProgress ? true : this.validate();

    if (this.state.shouldRedirect) {
      return (
        <Redirect to={this.redirectPath()}/>
      );
      // leanpub-end-insert
    } else {
      let errorDiv = ''
      let loading = this.state.loginInProgress ?  (<div className="ui active inverted dimmer">
          <div className="ui text loader">Verifica credenziali in corso...</div>
        </div>) : ''

      if (this.state.errorMsg !== '') {
        errorDiv = (
          <div className="ui error message">
            <div className="header">Autenticazione fallita</div>
            <p>{this.state.errorMsg}</p>
          </div>
        )
        formClass = 'ui form error'
      }
      return (
        <div id="loginBackground" style={{height: '100%'}}>
          <div className="ui container">
            <div className="ui centered stackable grid">
              <div className="six wide column">
                <div className="ui segments">
                  <div className="ui inverted blue padded segment">

                    <div className="item">
                      <div className="ui small image">
                        <img src="/images/logo-sbpiu.png" width="62px" height="62px" alt={client.getNomeApp()}/>
                      </div>
                      <div className="content">
                        <div className=" header">
                          <h2>Inserisci le tue credenziali:</h2>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="ui segment">
                    {loading}
                    <form className={formClass} action="#" method="GET">

                      <div className="field">
                        <Field
                          autoFocus={true}
                          className='ui left icon input'
                          placeholder='Username'
                          autocomplete='username'
                          name='username'
                          type='text'
                          value={this.state.fields.username}
                          onChange={this.onInputChange}
                          validate={(val) => (val ? false : 'Username obbligatorio')}
                        >
                          <i className="user icon"></i>
                        </Field>
                      </div>
                      <div className='field'>
                        <Field
                          className='ui left icon input'
                          placeholder='Password'
                          name='password'
                          type='password'
                          autocomplete='current-password'
                          value={this.state.fields.password}
                          onChange={this.onInputChange}
                          validate={(val) => (val ? false : 'Password obbligatoria')}
                        >
                          <i className="lock icon"></i>
                        </Field>

                      </div>
                      <div className="field">
                        <Checkbox
                            className='ui checkbox'
                            name='rememberme'
                            value={this.state.fields.rememberme}
                            onChange={this.onInputChange}
                        >
                          <label>Ricordami</label>
                        </Checkbox>

                      </div>
                      {errorDiv}
                      <button
                        className="ui big fluid blue icon button"
                        type="submit"
                        onClick={this.performLogin}
                        disabled={submitBtnDisabled}
                      >Log In <i className="sign in icon"></i></button>
                    </form>

                  </div>
                  <div className="ui secondary segment center aligned">
                    <p>{client.getNomeApp()} - {client.getVersione()}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      );
    }
  }
}

export default Login;



/** WEBPACK FOOTER **
 ** ./src/components/Login.js
 **/